var abilitiesIta = {
    "1": "Tanfo",
    "2": "Piovischio",
    "3": "Acceleratore",
    "4": "Lottascudo",
    "5": "Vigore",
    "6": "Umidit\u00e0",
    "7": "Scioltezza",
    "8": "Sabbiavelo",
    "9": "Statico",
    "10": "Assorbivolt",
    "11": "Assorbacqua",
    "12": "Indifferenza",
    "13": "Antimeteo",
    "14": "Insettocchi",
    "15": "Insonnia",
    "16": "Cambiacolore",
    "17": "Immunit\u00e0",
    "18": "Fuocardore",
    "19": "Polvoscudo",
    "20": "Mente Locale",
    "21": "Ventose",
    "22": "Prepotenza",
    "23": "Pedinombra",
    "24": "Cartavetro",
    "25": "Magidifesa",
    "26": "Levitazione",
    "27": "Spargispora",
    "28": "Sincronismo",
    "29": "Corpochiaro",
    "30": "Alternacura",
    "31": "Parafulmine",
    "32": "Leggiadro",
    "33": "Nuotovelox",
    "34": "Clorofilla",
    "35": "Risplendi",
    "36": "Traccia",
    "37": "Macroforza",
    "38": "Velenopunte",
    "39": "Forza Interiore",
    "40": "Magmascudo",
    "41": "Idrovelo",
    "42": "Magnetismo",
    "43": "Antisuono",
    "44": "Copripioggia",
    "45": "Sabbiafiume",
    "46": "Pressione",
    "47": "Grassospesso",
    "48": "Sveglialampo",
    "49": "Corpodifuoco",
    "50": "Fugafacile",
    "51": "Sguardofermo",
    "52": "Ipertaglio",
    "53": "Raccolta",
    "54": "Pigrone",
    "55": "Tuttafretta",
    "56": "Incantevole",
    "57": "Pi\u00f9",
    "58": "Meno",
    "59": "Previsioni",
    "60": "Antifurto",
    "61": "Muta",
    "62": "Dentistretti",
    "63": "Pelledura",
    "64": "Melma",
    "65": "Erbaiuto",
    "66": "Aiutofuoco",
    "67": "Acquaiuto",
    "68": "Aiutinsetto",
    "69": "Testadura",
    "70": "Siccit\u00e0",
    "71": "Trappoarena",
    "72": "Spiritovivo",
    "73": "Fumochiaro",
    "74": "Forzapura",
    "75": "Guscioscudo",
    "76": "Riparo",
    "77": "Intricopiedi",
    "78": "Elettrorapid",
    "79": "Antagonismo",
    "80": "Cuordeciso",
    "81": "Mantelneve",
    "82": "Voracit\u00e0",
    "83": "Grancollera",
    "84": "Agiltecnica",
    "85": "Antifuoco",
    "86": "Disinvoltura",
    "87": "Pellearsa",
    "88": "Download",
    "89": "Ferropugno",
    "90": "Velencura",
    "91": "Adattabilit\u00e0",
    "92": "Abillegame",
    "93": "Idratazione",
    "94": "Solarpotere",
    "95": "Piedisvelti",
    "96": "Normalit\u00e0",
    "97": "Cecchino",
    "98": "Magicscudo",
    "99": "Nullodifesa",
    "100": "Rallentatore",
    "101": "Tecnico",
    "102": "Fogliamanto",
    "103": "Impaccio",
    "104": "Rompiforma",
    "105": "Supersorte",
    "106": "Scoppio",
    "107": "Presagio",
    "108": "Premonizione",
    "109": "Imprudenza",
    "110": "Lentifumé",
    "111": "Filtro",
    "112": "Lentoinizio",
    "113": "Nervisaldi",
    "114": "Acquascolo",
    "115": "Corpogelo",
    "116": "Solidroccia",
    "117": "Scendineve",
    "118": "Mielincetta",
    "119": "Indagine",
    "120": "Temerariet\u00e0",
    "121": "Multitipo",
    "122": "Regalfiore",
    "123": "Sogniamari",
    "124": "Arraffalesto",
    "125": "Forzabruta",
    "126": "Inversione",
    "127": "Agitazione",
    "128": "Agonismo",
    "129": "Sconforto",
    "130": "Corpofunesto",
    "131": "Curacuore",
    "132": "Amicoscudo",
    "133": "Sottilguscio",
    "134": "Metalpesante",
    "135": "Metalleggero",
    "136": "Multisquame",
    "137": "Velenimpeto",
    "138": "Bruciaimpeto",
    "139": "Coglibacche",
    "140": "Telepatia",
    "141": "Altalena",
    "142": "Copricapo",
    "143": "Velentocco",
    "144": "Rigenergia",
    "145": "Pettinfuori",
    "146": "Remasabbia",
    "147": "Splendicute",
    "148": "Ponderazione",
    "149": "Illusione",
    "150": "Sosia",
    "151": "Intrapasso",
    "152": "Mummia",
    "153": "Arroganza",
    "154": "Giustizia",
    "155": "Paura",
    "156": "Magispecchio",
    "157": "Mangiaerba",
    "158": "Burla",
    "159": "Silicoforza",
    "160": "Spineferrate",
    "161": "Stato Zen",
    "162": "Vittorstella",
    "163": "Piroturbina",
    "164": "Teravolt",
    "165": "Aromavelo",
    "166": "Fiorvelo",
    "167": "Guancegonfie",
    "168": "Mutatipo",
    "169": "Foltopelo",
    "170": "Prestigiatore",
    "171": "Antiproiettile",
    "172": "Tenacia",
    "173": "Ferromascella",
    "174": "Pellegelo",
    "175": "Dolcevelo",
    "176": "Accendilotta",
    "177": "Aliraffica",
    "178": "Megalancio",
    "179": "Peloderba",
    "180": "Simbiosi",
    "181": "Unghiedure",
    "182": "Pellefolletto",
    "183": "Viscosit\u00e0",
    "184": "Pellecielo",
    "185": "Amorefiliale",
    "186": "Auratetra",
    "187": "Aurafolletto",
    "188": "Frangiaura",
    "189": "Mare Primordiale",
    "190": "Terra Estrema",
    "191": "Flusso Delta",
    "192": "Sopportazione",
    "193": "Fuggifuggi",
    "194": "Passoindietro",
    "195": "Idrorinforzo",
    "196": "Spietatezza",
    "197": "Scudosoglia",
    "198": "Sorveglianza",
    "199": "Bolladacqua",
    "200": "Tempracciaio",
    "201": "Furore",
    "202": "Spalaneve",
    "203": "Distacco",
    "204": "Idrovoce",
    "205": "Primacura",
    "206": "Pellelettro",
    "207": "Codasurf",
    "208": "Banco",
    "209": "Fantasmanto",
    "210": "Morfosintonia",
    "211": "Sciamefusione",
    "212": "Corrosione",
    "213": "Sonno Assoluto",
    "214": "Regalit\u00e0",
    "215": "Espellinterno",
    "216": "Sincrodanza",
    "217": "Batteria",
    "218": "Morbidone",
    "219": "Corposgargiante",
    "220": "Cuoreanima",
    "221": "Boccolidoro",
    "222": "Ricezione",
    "223": "Forza Chimica",
    "224": "Ultraboost",
    "225": "Sistema Primevo",
    "226": "Elettrogenesi",
    "227": "Psicogenesi",
    "228": "Nebbiogenesi",
    "229": "Erbogenesi",
    "230": "Metalprotezione",
    "231": "Spettroguardia",
    "232": "Scudoprisma",
    "233": "Cerebroforza",
    "234": "Spada Indomita",
    "235": "Scudo Saldo",
    "236": "Libero",
    "237": "Raccattapalle",
    "238": "Lanugine",
    "239": "Elicopinna",
    "240": "Blindospecchio",
    "241": "Inghiottimissile",
    "242": "Volont\u00e0 di Ferro",
    "243": "Vapormacchina",
    "244": "Punk Rock",
    "245": "Sputasabbia",
    "246": "Geloscaglie",
    "247": "Maturazione",
    "248": "Gelofaccia",
    "249": "Fonte Energetica",
    "250": "Mimetismo",
    "251": "Annullabarriere",
    "252": "Spiritoferreo",
    "253": "Ultimotocco",
    "254": "Anima Errante",
    "255": "Vigorilla",
    "256": "Gas Reagente",
    "257": "Pastelvelo",
    "258": "Pancialterna",
    "259": "Colpolesto",
    "260": "Pugni Invisibili",
    "261": "Stranofarmaco",
    "262": "Transistor",
    "263": "Dragomascelle",
    "264": "Nitrito Bianco",
    "265": "Nitrito Nero",
    "266": "Sintonia Equina",
    "267": "Sintonia Equina",
    "268": "Odore Tenace",
    "269": "Spargisemi",
    "270": "Termoscambio",
    "271": "Iraguscio",
    "272": "Sale Purificante",
    "273": "Bentostato",
    "274": "Vento Propizio",
    "275": "Cane da Guardia",
    "276": "Portamassi",
    "277": "Energia Eolica",
    "278": "Supercambio",
    "279": "Torre di Comando",
    "280": "Convertivolt",
    "281": "Paleoattivazione",
    "282": "Carica Quark",
    "283": "Corpo Aureo",
    "284": "Vaso Nefasto",
    "285": "Spada Nefasta",
    "286": "Amuleto Nefasto",
    "287": "Monile Nefasto",
    "288": "Ritmo d'Oricalco",
    "289": "Motore Adronico",
    "290": "Scrocco",
    "291": "Ruminante",
    "292": "Affilama",
    "293": "Generale Supremo",
    "294": "Coprotagonismo",
    "295": "Mantossina",
    "296": "Codarmatura",
    "297": "Mangiaterra",
    "298": "Micoforza",
    "299": "Ospitalit\u00e0",
    "300": "Occhio Interiore",
    "301": "Albergamemorie",
    "302": "Albergamemorie",
    "303": "Albergamemorie",
    "304": "Albergamemorie",
    "305": "Catena Tossica",
    "306": "Sciroppo Sublime",
    "307": "Teramorfosi",
    "308": "Teraguscio",
    "309": "Zeroformazione"
}
export default abilitiesIta;